module.exports = __webpack_public_path__ + "img/model-img3.dba80655.png";